import React from 'react'
import { Grid, PageSection as Section, VerticalSpacer, Lockup, Lazy } from '@superhi/design'

import { Video, VideoWrapper } from './styles'
import { DATA } from './config'

const GRID_1_ROW_GAP = { small: 32, medium: 40, large: 48, xlarge: 48 }
const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 6,
}
const VS_1 = { small: 20, medium: 24, large: 24 }
const VS_2 = { small: 6, medium: 6, large: 8 }

const Features: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Section
    title="See what it can do"
    collapseTopPadding
    decorationName="triangle"
    decorationPosition="bottom-right"
    collapseBottomPadding
    headingLevel={2}
  >
    <Grid rowGap={GRID_1_ROW_GAP}>
      {DATA.map((item) => (
        <Grid.Cell key={item.title} span={GRID_1_CELL_SPAN_1}>
          <VerticalSpacer amount={VS_1}>
            <Lazy triggerOnce>
              {({ ref, inView }) => (
                <VideoWrapper ref={ref}>
                  {inView && <Video src={item.videoUrl} autoPlay muted playsInline />}
                </VideoWrapper>
              )}
            </Lazy>
            <VerticalSpacer amount={VS_2}>
              <Lockup
                level="4"
                title={item.title}
                titleColor="GREY_90"
                subtitle={item.subtitle}
                align="left"
                headingLevel={3}
              />
            </VerticalSpacer>
          </VerticalSpacer>
        </Grid.Cell>
      ))}
    </Grid>
  </Section>
)

export default Features
